import moment from "moment";
export var DateToDateTimeString = function (date) {
    if (!date) {
        return "";
    }
    date = new Date(date);
    return "".concat(DateToDateString(date), " ").concat(DateToTimeString(date));
};
export var DateToDateString = function (date) {
    if (!date) {
        return "";
    }
    date = new Date(date);
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()]
        .map(function (x) { return x.toString(); })
        .map(function (x) { return x.length === 1 ? "0" + x : x; })
        .join("-");
};
export var DateToTimeString = function (date) {
    if (!date) {
        return "";
    }
    date = new Date(date);
    return [date.getHours(), date.getMinutes()]
        .map(function (x) { return x.toString(); })
        .map(function (x) { return x.length === 1 ? "0" + x : x; })
        .join(":");
};
export var valueAsNum = function (value) { return (typeof value === "number" ? value :
    !!value ? parseFloat(value) : 0); };
export var isNegative = function (amount) { return (amount < 0); };
export var BytesToFileSizeString = function (bytes) {
    var unitLabels = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    var unit = bytes;
    var i = 0;
    while (unit >= 1024) {
        unit = unit / 1024;
        i++;
    }
    unit = unit * 10;
    unit = Math.floor(unit);
    unit = unit / 10;
    return "".concat(unit, " ").concat(unitLabels[i]);
};
export var formatedDateOfBirth = function (DateOfBirth) { return (DateOfBirth.toString().split("-").reverse().join("-")); };
export var formattedDate = function (date) { return (date.toISOString().slice(0, 10)); };
export var formatDateString = function (d, format) {
    if (!!d && typeof d === "string") {
        var isMomentDate = moment(d);
        if (isMomentDate.isValid()) {
            var xyz = isMomentDate.format(format !== null && format !== void 0 ? format : "DD-MM-YYYY");
            return xyz;
        }
        else {
            return d;
        }
    }
    else {
        return d;
    }
};
export var formatedCurrentDate = function (d) {
    var month = (d.getMonth() + 1).toString();
    var day = d.getDate().toString();
    var year = d.getFullYear();
    if (month.length < 2) {
        month = "0" + month;
    }
    if (day.length < 2) {
        day = "0" + day;
    }
    return [day, month, year].join("-");
};
export var licensePlate = function (license) {
    var plate = license.split(/([0-9]+)/).join("-");
    if (plate.charAt(0) === "-") {
        plate = plate.slice(1);
    }
    if (plate.charAt(plate.length - 1) === "-") {
        plate = plate.slice(0, plate.length - 1);
    }
    return plate;
};
